export const entryList = [
  {
    No: 1,
    Name: "オオタク",
    Team: "越路カレーメシ",
    Machine: "RR2T250",
    Comment: "やるぞ",
    Twitter: "",
  },
  {
    No: 2,
    Name: "ゆうま",
    Team: "ジパングウイスキー",
    Machine: "te250",
    Comment: "がんばるぞー！",
    Twitter: "",
  },
  {
    No: 3,
    Name: "うえはら",
    Team: "TEAMヘタレオフローダー",
    Machine: "YZ125X",
    Comment: "ご安全に",
    Twitter: "",
  },
  {
    No: 4,
    Name: "ちゃっぴ",
    Team: "村田塾",
    Machine: "RR300",
    Comment: "ツーリング気分",
    Twitter: "",
  },
  {
    No: 5,
    Name: "天氏",
    Team: "ドンガラモータース",
    Machine: "KTM 250 EXC TPI SIX DAYS",
    Comment: "がんばるぞー！！",
    Twitter: "",
  },
  {
    No: 6,
    Name: "ろむな",
    Team: "村田塾",
    Machine: "X-trainer 250",
    Comment: "久しぶりのレース頑張ります！",
    Twitter: "",
  },
  {
    No: 7,
    Name: "佐古祥太郎",
    Team: "RAC",
    Machine: "セロー225",
    Comment: "頑張ります！",
    Twitter: "",
  },
  {
    No: 8,
    Name: "よこだす",
    Team: "RAC",
    Machine: "RR2T",
    Comment: "",
    Twitter: "",
  },
  {
    No: 9,
    Name: "motoyasu",
    Team: "おしるこ組合",
    Machine: "X-Trainer250",
    Comment: "砕石の頂上目指して??",
    Twitter: "",
  },
  {
    No: 10,
    Name: "ざの",
    Team: "つばさ組feat. Suzukiしごかれ隊",
    Machine: "YZ125X",
    Comment: "タマイチ！",
    Twitter: "",
  },
  {
    No: 11,
    Name: "こばたく",
    Team: "つるっぱげレーシング",
    Machine: "卑猥Z",
    Comment: "イきまくりングス！",
    Twitter: "",
  },
  {
    No: 12,
    Name: "イゴリカワ",
    Team: "和田屋SRC（仮）",
    Machine: "YZ125X",
    Comment: "俺が！いちばん！イゴる！！！！！",
    Twitter: "",
  },
  {
    No: 13,
    Name: "ざこっぱ",
    Team: "内燃機関研究部OB",
    Machine: "YZ125",
    Comment: "魂一やらせてください",
    Twitter: "",
  },
  {
    No: 14,
    Name: "sban",
    Team: "",
    Machine: "KX100",
    Comment: "全力で楽しみます！",
    Twitter: "",
  },
  {
    No: 15,
    Name: "あつ",
    Team: "TRI",
    Machine: "RR2T",
    Comment: "",
    Twitter: "",
  },
  {
    No: 16,
    Name: "ike",
    Team: "feat suzukiしごかれ隊",
    Machine: "YZ125X",
    Comment: "タマイチ",
    Twitter: "",
  },
  {
    No: 17,
    Name: "伊藤 優樹",
    Team: "",
    Machine: "クロストレーナー",
    Comment: "新車おろしたて。目指せ無傷！",
    Twitter: "",
  },
  {
    No: 18,
    Name: "井上 季明",
    Team: "choco's factory",
    Machine: "YZ125X",
    Comment: "生き残る。",
    Twitter: "",
  },
  {
    No: 19,
    Name: "門間 賢介",
    Team: "Wave Factory RT",
    Machine: "KTM EXC250TPI",
    Comment: "",
    Twitter: "",
  },
  {
    No: 20,
    Name: "センチネル",
    Team: "ミドルオフロード",
    Machine: "EXC-F250",
    Comment: "完走目指して頑張ります！",
    Twitter: "",
  },
  {
    No: 21,
    Name: "たおる",
    Team: "村田塾",
    Machine: "X-Trainer250",
    Comment: "肩幅ゴールド帯",
    Twitter: "",
  },
  {
    No: 22,
    Name: "チョコボーイ山口",
    Team: "choco's factory",
    Machine: "hasqvarna te250i",
    Comment: "魂1目指して頑張るぞい☆",
    Twitter: "",
  },
  {
    No: 23,
    Name: "ぐら",
    Team: "足跡組",
    Machine: "KTM 150XCW",
    Comment: "人の森に足跡を残します！",
    Twitter: "",
  },
  {
    No: 24,
    Name: "kou",
    Team: "村田塾",
    Machine: "クロストレーナー250",
    Comment: "魂1やるぞ",
    Twitter: "",
  },
  {
    No: 25,
    Name: "morioka",
    Team: "suzukiしごかれ隊",
    Machine: "beta xtrainer",
    Comment: "",
    Twitter: "",
  },
  {
    No: 26,
    Name: "カマヤ",
    Team: "",
    Machine: "フサベルTE250",
    Comment: "楽しむ??",
    Twitter: "",
  },
  {
    No: 27,
    Name: "森耕輔",
    Team: "YAMAHA MOTOCROSS CLUB",
    Machine: "YZ250X",
    Comment: "",
    Twitter: "",
  },
  {
    No: 28,
    Name: "CRoW",
    Team: "タピ：rock",
    Machine: "yz125x",
    Comment: "初HED頑張ります！",
    Twitter: "",
  },
  {
    No: 29,
    Name: "緒方悠貴",
    Team: "CLUB TECHNIX",
    Machine: "RM250",
    Comment: "",
    Twitter: "",
  },
  {
    No: 30,
    Name: "えっくん",
    Team: "SANZOKU",
    Machine: "KTMexc",
    Comment: "",
    Twitter: "",
  },
  {
    No: 31,
    Name: "モーケン中尉",
    Team: "おしるこ組合",
    Machine: "FREERIDE350",
    Comment: "怪我なく時間いっぱいイゴり散らかすのが目標です！",
    Twitter: "",
  },
  {
    No: 32,
    Name: "嬉野和也",
    Team: "",
    Machine: "CRF250X",
    Comment: "初参加です。よろしくお願い致します。",
    Twitter: "",
  },
  {
    No: 33,
    Name: "ミサイル井口",
    Team: "choco's factory",
    Machine: "YZ125X",
    Comment: "初心者ですけど頑張ります！",
    Twitter: "",
  },
  {
    No: 34,
    Name: "ばら",
    Team: "TEAMへたれオフローダー",
    Machine: "YZ250X",
    Comment: "",
    Twitter: "",
  },
  {
    No: 35,
    Name: "んとんた",
    Team: "和田家SRC",
    Machine: "YZ250X",
    Comment: "ｶﾞﾝﾊﾞﾘﾏｽ",
    Twitter: "",
  },
  {
    No: 36,
    Name: "小川尚人",
    Team: "",
    Machine: "XTRAINER",
    Comment: "",
    Twitter: "",
  },
  {
    No: 37,
    Name: "まこつ",
    Team: "sanzoKu",
    Machine: "ktm",
    Comment: "iyw",
    Twitter: "",
  },
  {
    No: 38,
    Name: "永井隼斗",
    Team: "TCU-MCC@BOSCH",
    Machine: "YZ250X",
    Comment: "がんばります",
    Twitter: "",
  },
  {
    No: 39,
    Name: "KOMATSU",
    Team: "",
    Machine: "X-Trainer250LD",
    Comment: "自分との戦い！！",
    Twitter: "",
  },
  {
    No: 40,
    Name: "潤デューロ",
    Team: "JUNDURO ENDURANCE TEAM",
    Machine: "クロストレーナー300",
    Comment: "ゴールを目指し怪我無く楽しみます！",
    Twitter: "",
  },
  {
    No: 41,
    Name: "ジョニーこーたー",
    Team: "K's Racing",
    Machine: "EXC",
    Comment: "",
    Twitter: "",
  },
  {
    No: 42,
    Name: "えこたま",
    Team: "Webikeオフロード部&キャンオフ老害組",
    Machine: "RM250",
    Comment: "一周！",
    Twitter: "",
  },
  {
    No: 43,
    Name: "らいすD",
    Team: "ラジエーターズ",
    Machine: "FE250",
    Comment: "やるぞやるぞやるぞ！",
    Twitter: "",
  },
  {
    No: 44,
    Name: "いまっぽ",
    Team: "",
    Machine: "YZ250",
    Comment: "はてさて、どうなることやら？",
    Twitter: "",
  },
  {
    No: 45,
    Name: "ツトム",
    Team: "ラジエーターズ",
    Machine: "X-TRAINER250",
    Comment: "ラジッ！",
    Twitter: "",
  },
  {
    No: 46,
    Name: "にし",
    Team: "左近山登山部",
    Machine: "KX250X",
    Comment: "",
    Twitter: "",
  },
  {
    No: 47,
    Name: "DNS骨折ライダー",
    Team: "TRI練習走行骨折部門",
    Machine: "KTM450exc",
    Comment: "なんとか一周…",
    Twitter: "",
  },
  {
    No: 48,
    Name: "村田哲也",
    Team: "WaveFactoryRT",
    Machine: "KTM250EXC",
    Comment: "",
    Twitter: "",
  },
  {
    No: 49,
    Name: "SASUKE",
    Team: "Funny's Custom Service&TOYZRacing with ゆるオフざけ部",
    Machine: "BetaRR2T200",
    Comment: "はじめてのハードエンデューロ！楽しみます！！",
    Twitter: "",
  },
  {
    No: 50,
    Name: "SLORIDE",
    Team: "RAC",
    Machine: "SL230",
    Comment: "",
    Twitter: "",
  },
  {
    No: 51,
    Name: "よっぴー",
    Team: "E.D.Racing",
    Machine: "クロストレーナー250",
    Comment: "頑張ります！",
    Twitter: "",
  },
  {
    No: 52,
    Name: "中島みゆき",
    Team: "RAC",
    Machine: "FREERIDE250R",
    Comment: "",
    Twitter: "",
  },
  {
    No: 53,
    Name: "ブンブン",
    Team: "",
    Machine: "フサベル",
    Comment: "頑張る。",
    Twitter: "",
  },
  {
    No: 54,
    Name: "はちょり",
    Team: "K's Racing",
    Machine: "300 EXC TPI",
    Comment: "",
    Twitter: "",
  },
  {
    No: 55,
    Name: "上村 修",
    Team: "TRI",
    Machine: "ktm 250exc 2003年式",
    Comment: "35年ぶりのレース、楽しみます?? 魂一決めたいなーー??",
    Twitter: "",
  },
  {
    No: 56,
    Name: "Usohachi",
    Team: "吉田ジンギスカン千葉店",
    Machine: "KTM 150XC-W",
    Comment: "やるぞ！やるぞ！やるぞー！",
    Twitter: "",
  },
  {
    No: 57,
    Name: "ロットン",
    Team: "KMTモータース",
    Machine: "klx150BF",
    Comment: "やってやるだけ",
    Twitter: "",
  },
  {
    No: 58,
    Name: "ソンデン",
    Team: "吉田ジンギスカン",
    Machine: "WR250F",
    Comment: "やれるだけやります",
    Twitter: "",
  },
  {
    No: 59,
    Name: "藤森",
    Team: "ICEL OFF ROAD",
    Machine: "XR230 TYPE R",
    Comment: "Give a Reason",
    Twitter: "",
  },
  {
    No: 60,
    Name: "awn",
    Team: "FFFE ADV CLUB dot TRST SCH.",
    Machine: "KTM250exc",
    Comment: "知足安分巣林一枝飲河満腹隠忍自重",
    Twitter: "",
  },
  {
    No: 61,
    Name: "永原弘行",
    Team: "ノーザンウォーカーズ",
    Machine: "KTM 300EXC",
    Comment: "",
    Twitter: "",
  },
  {
    No: 62,
    Name: "ぎゃーさん",
    Team: "",
    Machine: "BETA３００",
    Comment: "目標タマイチ??",
    Twitter: "",
  },
  {
    No: 63,
    Name: "ペリカン",
    Team: "RMX's(アールズ)",
    Machine: "RMX250S",
    Comment: "RMX耀かせます",
    Twitter: "",
  },
  {
    No: 64,
    Name: "グンマー",
    Team: "M.F.M.+UnitedOIL",
    Machine: "RR4T390",
    Comment: "一度ぐらいクロスミッションでチェッカー受けたい",
    Twitter: "",
  },
  {
    No: 65,
    Name: "カヲルトリッカー",
    Team: "Teamヘタレオフローダー&TRI",
    Machine: "トリッカー",
    Comment: "ま、負けないんだからねっ！",
    Twitter: "",
  },
  {
    No: 66,
    Name: "つばき",
    Team: "Team JE",
    Machine: "250EXC tpi",
    Comment: "このレースが終わったら焼肉に行くんだ。",
    Twitter: "",
  },
  {
    No: 67,
    Name: "うなぎ",
    Team: "クレィジーマウンテン",
    Machine: "ベータクロストレーナー",
    Comment: "怪我無く頑張ります",
    Twitter: "",
  },
  {
    No: 68,
    Name: "裏のヒデヲ",
    Team: "ラジエーターズ",
    Machine: "当日までに買っておきます",
    Comment: "ラジッ！",
    Twitter: "",
  },
  {
    No: 69,
    Name: "AD／tac",
    Team: "TeamBetaストレンジIRC",
    Machine: "RR480",
    Comment: "楽しみます",
    Twitter: "",
  },
  {
    No: 70,
    Name: "晴輝",
    Team: "ICEL",
    Machine: "TE125",
    Comment: "",
    Twitter: "",
  },
  {
    No: 71,
    Name: "やまぴー",
    Team: "MFM. with STW UnitedOil MCJapan",
    Machine: "RR2T300",
    Comment: "谷川はいやだぁ！",
    Twitter: "",
  },
  {
    No: 72,
    Name: "アルフ",
    Team: "HYeNA",
    Machine: "TE150i",
    Comment: "楽しみ！",
    Twitter: "",
  },
  {
    No: 73,
    Name: "おさ",
    Team: "",
    Machine: "KTM250EXC",
    Comment: "ぶっちぎり一位！！！！",
    Twitter: "",
  },
  {
    No: 74,
    Name: "雪山に住むカモシカ",
    Team: "吉田ジンギスカン猿ケ島店with150友の会",
    Machine: 150,
    Comment: "地元猿ケ島勢として意地でも周回を",
    Twitter: "",
  },
  {
    No: 75,
    Name: "林 宏志",
    Team: "葛城組+Sat's+SHINKO",
    Machine: "TE250i",
    Comment: "",
    Twitter: "",
  },
  {
    No: 76,
    Name: "ピヨ彦",
    Team: "和田屋SRC白井HED本格派",
    Machine: "ドドゴリックス300トピ",
    Comment: "今は亡きトドゴリさんの意志を、ゴールまで、、、",
    Twitter: "",
  },
  {
    No: 77,
    Name: "ゆあさん",
    Team: "",
    Machine: "KTM 250EXC",
    Comment: "楽しみます...怖い...",
    Twitter: "",
  },
  {
    No: 78,
    Name: "アツポン",
    Team: "",
    Machine: "TE150i",
    Comment: "一周できるかな",
    Twitter: "",
  },
  {
    No: 79,
    Name: "NOSHIRO456",
    Team: "釜石S.S.F with Chicken Racing",
    Machine: "YZ144X",
    Comment: "倒しません",
    Twitter: "",
  },
  {
    No: 80,
    Name: "T@24",
    Team: "",
    Machine: "125exc",
    Comment: "ガンバル！！",
    Twitter: "",
  },
  {
    No: 81,
    Name: "ニシム?ラディン",
    Team: "OKANIVA RACING(下っ端)",
    Machine: "TE250i",
    Comment: "F?d?ration Internationale de Motocyclisme",
    Twitter: "",
  },
  {
    No: 82,
    Name: "富塚 龍助",
    Team: "WaveFactoryRT & 富塚豆腐店",
    Machine: "KTM 250EXC-F Six Days",
    Comment:
      "地元開催なので、エントリーしました！技術的にも絶対に無謀なのは分かってるんですけど、記念に参加してみたかったんです！応援宜しくお願い致します！！",
    Twitter: "",
  },
  {
    No: 83,
    Name: "うえの",
    Team: "HRTK-RACING",
    Machine: "ハスクバーナ",
    Comment: "",
    Twitter: "",
  },
  {
    No: 84,
    Name: "はーばー",
    Team: "カネゴンパーティー",
    Machine: "KTM 250 EXC",
    Comment: "",
    Twitter: "",
  },
  {
    No: 85,
    Name: "Matisu Moto",
    Team: "Team フロンティア",
    Machine: "KTM 250EXC TPI",
    Comment: "いけるところまでいきたい(／・ω・)／",
    Twitter: "",
  },
  {
    No: 86,
    Name: "チャンポン",
    Team: "KWK塾",
    Machine: "KTM 250EXC TPI",
    Comment: "頑張るマン",
    Twitter: "",
  },
  {
    No: 87,
    Name: "橋口 克哉",
    Team: "Team LANG with ペリカン",
    Machine: "250EXC",
    Comment: "楽しく、華麗にMISSIONクリア",
    Twitter: "",
  },
  {
    No: 88,
    Name: "nanaoki.so.ei",
    Team: "",
    Machine: "te250i",
    Comment: "全力で楽しみます??",
    Twitter: "",
  },
  {
    No: 89,
    Name: "なおと",
    Team: "ゆるオフざけ部",
    Machine: "yz125x",
    Comment: "将来のエルズ参加に向けてやらしてもらいます！",
    Twitter: "",
  },
  {
    No: 90,
    Name: "Yasuaki",
    Team: "MAD PEEPZ",
    Machine: "yz125",
    Comment: "素人だからってなめんなよクソ野郎！",
    Twitter: "",
  },
  {
    No: 91,
    Name: "嶋崎友一朗",
    Team: "元帥",
    Machine: "yz250x",
    Comment: "",
    Twitter: "",
  },
  {
    No: 92,
    Name: "安齋建人",
    Team: "ICEL OFF ROAD",
    Machine: "SL230",
    Comment: "",
    Twitter: "",
  },
  {
    No: 93,
    Name: "ツッキー",
    Team: "PSエディ",
    Machine: "betaクロトレ",
    Comment: "そろそろ本気出します！",
    Twitter: "",
  },
  {
    No: 94,
    Name: "ウメヤマ",
    Team: "TCU-MCC@BOSCH",
    Machine: "YZ250FX",
    Comment: "",
    Twitter: "",
  },
  {
    No: 95,
    Name: "コシダン",
    Team: "TGCマッスルレーシング＆フレアライン",
    Machine: "YAMAHA YZ250X",
    Comment: "地元開催頑張ります！！",
    Twitter: "",
  },
  {
    No: 96,
    Name: "Sujiniku",
    Team: "エンジンももも",
    Machine: "YZ250X",
    Comment:
      "上手くなったら出るんじゃあない、下手くそでも出たいから出るんだ･･･俺はこのケゴンベルグで限界を超えるッ！",
    Twitter: "",
  },
  {
    No: 97,
    Name: "ペリカン店長BUN",
    Team: "TEAM LANG with Pelican",
    Machine: "YAMAHA YZ125Ｘ",
    Comment: "宜しくお願いします",
    Twitter: "",
  },
  {
    No: 98,
    Name: "E-fatbikeジジィ",
    Team: "アイズ",
    Machine: "電動ファットバイク",
    Comment: "電動ファットバイクはローインパクト!",
    Twitter: "",
  },
  {
    No: 99,
    Name: "戸井田颯人",
    Team: "つっちーず",
    Machine: "yz250fx",
    Comment: "?",
    Twitter: "",
  },
  {
    No: 100,
    Name: "まーしー",
    Team: "オプちゃ會",
    Machine: "ﾄﾘｯｶｰ250",
    Comment: "２人で引っ張れば上がると思うの よろしくお願い致します",
    Twitter: "",
  },
  {
    No: 101,
    Name: "サッチン",
    Team: "単独",
    Machine: "ktm exc250tpi",
    Comment: "皆さんの走りを間近で見たいが為に参加します♪",
    Twitter: "",
  },
  {
    No: 102,
    Name: "坂登ヘタ郎ピカチュー乃助",
    Team: "TNP 白井エンデューロ本格派",
    Machine: "坂登じゃじゃ丸",
    Comment: "山に成る",
    Twitter: "",
  },
  {
    No: 103,
    Name: "ポンズ",
    Team: "",
    Machine: "TT250R",
    Comment: "",
    Twitter: "",
  },
  {
    No: 104,
    Name: "むちゅう",
    Team: "屋根下秘密クラブ",
    Machine: "ホモムカデ125X",
    Comment: "やるぞちゃ！",
    Twitter: "",
  },
  {
    No: 105,
    Name: "おじゃわ",
    Team: "FUNAI RACING",
    Machine: "YZ125X",
    Comment: "",
    Twitter: "",
  },
  {
    No: 106,
    Name: "田澤 啓明",
    Team: "",
    Machine: "FE250",
    Comment: "ハードエンデューロ初参加ですが、何か。",
    Twitter: "",
  },
  {
    No: 107,
    Name: "本澤 勝",
    Team: "本澤会",
    Machine: "250EXC",
    Comment: "ケガしない程度にガンバります。",
    Twitter: "",
  },
  {
    No: 108,
    Name: "Ｔ中",
    Team: "本澤会",
    Machine: "300EXC",
    Comment: "痛風でブーツが履けるか心配です",
    Twitter: "",
  },
  {
    No: 109,
    Name: "おてんばパパくま",
    Team: "KTM群馬",
    Machine: "KTM 250exctpi",
    Comment: "絶望感からの魂イチ無限ループ中(ｰ ｰ;)",
    Twitter: "",
  },
  {
    No: 110,
    Name: "ぎゃーさん",
    Team: "",
    Machine: "rr2t",
    Comment: "タマイチ??",
    Twitter: "",
  },
  {
    No: 111,
    Name: "まぐろ屋 たけちゃん",
    Team: "豊洲魚市場林道部",
    Machine: "KTM EXC 300 TPI",
    Comment: "ケゴンベルグ初代チャンピオン目指します??",
    Twitter: "",
  },
  {
    No: 112,
    Name: "運び屋 みーくん",
    Team: "豊洲魚市場林道部",
    Machine: "KTM250exc tpi  6days  2022",
    Comment: "初参加！胸お借りします！",
    Twitter: "",
  },
  {
    No: 113,
    Name: "ナッツ",
    Team: "150友の会 APEX部",
    Machine: "KTM 150XC-W",
    Comment: "APEXはHEDに効くという事を証明します",
    Twitter: "",
  },
  {
    No: 114,
    Name: "さわ G",
    Team: "チームS&S",
    Machine: "クロトレ",
    Comment: "今年も爺いガンバります",
    Twitter: "",
  },
  {
    No: 115,
    Name: "ONDA技研",
    Team: "チームS&S",
    Machine: "CRF230F",
    Comment: "おっさん頑張る！",
    Twitter: "",
  },
  {
    No: 116,
    Name: "燻し処 森",
    Team: "ROCK IN FOREST",
    Machine: "EXC250F",
    Comment: "",
    Twitter: "",
  },
  {
    No: 117,
    Name: "川口保亮",
    Team: "WAVE FACTORY RT",
    Machine: "KTM250EXC TPI",
    Comment: "怪我しませんように！",
    Twitter: "",
  },
  {
    No: 118,
    Name: "愛国戦士",
    Team: "オフ車會",
    Machine: "RR2T250",
    Comment: "今年はバイクに優しくをモットーに！",
    Twitter: "",
  },
  {
    No: 119,
    Name: "かとりさ",
    Team: "かとりさちゃんねる",
    Machine: "RR4T125LC(予定)",
    Comment: "動くパイロンになりに行きます",
    Twitter: "",
  },
  {
    No: 120,
    Name: "テジュン",
    Team: "ポンコツ医大生",
    Machine: "RR2T",
    Comment: "ハードエンデューロ初めてだけど頑張ります！泣",
    Twitter: "",
  },
  {
    No: 121,
    Name: "こんちゃん",
    Team: "林道旅団",
    Machine: "250EXC TPI",
    Comment: "仕上がりたい!!!",
    Twitter: "",
  },
  {
    No: 122,
    Name: "ihara",
    Team: "WP",
    Machine: "Husqvarna",
    Comment: "",
    Twitter: "",
  },
  {
    No: 123,
    Name: "こまっちゃん",
    Team: "WP",
    Machine: "GASGAS EC300",
    Comment: "しんどいのきらい",
    Twitter: "",
  },
  {
    No: 124,
    Name: "XRrr",
    Team: "",
    Machine: "Husaberg TE250",
    Comment: "はじめてのXXXです！",
    Twitter: "",
  },
  {
    No: 125,
    Name: "Taka",
    Team: "TRI",
    Machine: "",
    Comment: "感謝します！！",
    Twitter: "",
  },
  {
    No: 126,
    Name: "築井 豊",
    Team: "",
    Machine: "YZ250X",
    Comment: "",
    Twitter: "",
  },
  {
    No: 127,
    Name: "べーちゃん",
    Team: "アイアンレンジャー",
    Machine: "kTM 250EXC",
    Comment: "やったりまっせ！！！",
    Twitter: "",
  },
  {
    No: 128,
    Name: "石田トシユキ",
    Team: "FUNAI RACING",
    Machine: "RMX250S",
    Comment: "そろそろ働きます。",
    Twitter: "",
  },
  {
    No: 129,
    Name: "島田 和幸",
    Team: "",
    Machine: "フサクバーナTE250",
    Comment: "あんまりドイヒーなコースにしないでね??",
    Twitter: "",
  },
  {
    No: 130,
    Name: "ゴンのすけ",
    Team: "FOBC",
    Machine: "KTM250EXC",
    Comment: "ハードエンデューロを満喫するぞー！",
    Twitter: "",
  },
  {
    No: 131,
    Name: "南雲 剛",
    Team: "マウンテンミサイル神奈川",
    Machine: "YZ250FX",
    Comment: "",
    Twitter: "",
  },
  {
    No: 132,
    Name: "カツオ",
    Team: "小野家",
    Machine: "YZ125X",
    Comment: "親子で頑張ります",
    Twitter: "",
  },
  {
    No: 133,
    Name: "ゆーや",
    Team: "小野家",
    Machine: "YZ250F",
    Comment: "親父に負けないように頑張ります??",
    Twitter: "",
  },
  {
    No: 134,
    Name: "コムロヨシタカ",
    Team: "",
    Machine: "KTM250excf",
    Comment: "絶対無理！",
    Twitter: "",
  },
  {
    No: 135,
    Name: "ぶっ刺し先生",
    Team: "KOKOROCARE Racing",
    Machine: "GASGAS250",
    Comment: "エルズベルグロデオに向けて揉まれます！",
    Twitter: "",
  },
  {
    No: 136,
    Name: "白楽",
    Team: "",
    Machine: "husqvarna te250(08)",
    Comment: "レース初参加ですが行けるとこまで行きます！",
    Twitter: "",
  },
  {
    No: 137,
    Name: "わこー",
    Team: "",
    Machine: "250EXC",
    Comment: "自分に負けないよう頑張ります！",
    Twitter: "",
  },
  {
    No: 138,
    Name: "るう",
    Team: "本澤会",
    Machine: "KTM 250 EXC TPI",
    Comment: "行けるところまで！",
    Twitter: "",
  },
  {
    No: 139,
    Name: "鈴木 豊一",
    Team: "Wave Factory RT",
    Machine: "EXC",
    Comment: "",
    Twitter: "",
  },
  {
    No: 140,
    Name: "べーちゃん",
    Team: "おさ",
    Machine: "250EXC",
    Comment: "ぶっちぎり！！！",
    Twitter: "",
  },
  {
    No: 141,
    Name: "うーぽんユウガ",
    Team: "RIEJU関西TKC",
    Machine: "RIEJU MR300",
    Comment: "ブッサシ先生を追いかけてやる！",
    Twitter: "",
  },
  {
    No: 142,
    Name: "まんぷく",
    Team: "",
    Machine: "セロー225",
    Comment: "がんばります。",
    Twitter: "",
  },
  {
    No: 143,
    Name: "ひかるん",
    Team: "たくらや",
    Machine: "TE125",
    Comment: "今のバイクでレース初参戦！楽しむぞー！",
    Twitter: "",
  },
  {
    No: 144,
    Name: "岩橋雅也",
    Team: "",
    Machine: "YZ250FX",
    Comment: "タマイチ??",
    Twitter: "",
  },
  {
    No: 145,
    Name: "スーパーまさし君",
    Team: "和田屋SRC 2nd",
    Machine: "YAMAHA YZ250FX",
    Comment: "和田屋SRC 2nd 心を燃やせ！",
    Twitter: "",
  },
  {
    No: 146,
    Name: "まあぼ～",
    Team: "和田屋SRC2nd",
    Machine: "YZ250FX",
    Comment: "",
    Twitter: "",
  },
  {
    No: 147,
    Name: "太田 英伸",
    Team: "DFライコ柏オフロード部",
    Machine: "CRF150R2",
    Comment: "金子君置いてかないでね！",
    Twitter: "",
  },
  {
    No: 148,
    Name: "コースケくん",
    Team: "和田屋SRC 2nd",
    Machine: "YZ250FX",
    Comment: "やってやりますよ",
    Twitter: "",
  },
  {
    No: 149,
    Name: "佐々木文豊",
    Team: "アドブ",
    Machine: "TE300i",
    Comment: "",
    Twitter: "",
  },
  {
    No: 150,
    Name: "okaniva",
    Team: "白井 HED トライアル部 with 和田屋",
    Machine: "300EXC-TIP",
    Comment: "上手くなりたい",
    Twitter: "",
  },
  {
    No: 151,
    Name: "川D",
    Team: "NBC21",
    Machine: "TE250i",
    Comment: "仕上がった後のメシは美味い！",
    Twitter: "",
  },
  {
    No: 152,
    Name: "N.kawai",
    Team: "NBC21",
    Machine: "YZ125X",
    Comment: "がんばるっ！",
    Twitter: "",
  },
  {
    No: 153,
    Name: "清水特別顧問補佐",
    Team: "NBC21",
    Machine: "KTM EXCF350",
    Comment: "キャンプの方が得意です。",
    Twitter: "",
  },
  {
    No: 154,
    Name: "‥さん",
    Team: "NBC21",
    Machine: "YZ125",
    Comment: "",
    Twitter: "",
  },
  {
    No: 155,
    Name: "コバ",
    Team: "",
    Machine: "yz250x",
    Comment: "",
    Twitter: "",
  },
  {
    No: 156,
    Name: "齊藤 秀一",
    Team: "",
    Machine: "YZ125X",
    Comment: "生きて帰ります",
    Twitter: "",
  },
  {
    No: 157,
    Name: "シバヤマ",
    Team: "",
    Machine: "YZ125X",
    Comment: "",
    Twitter: "",
  },
  {
    No: 158,
    Name: "ちばてつ",
    Team: "足跡組",
    Machine: "KTM300EXC",
    Comment: "非日常、体験させていただきます",
    Twitter: "",
  },
  {
    No: 159,
    Name: "たろ",
    Team: "おやまーず",
    Machine: "クロストレーナー250",
    Comment: "やるぞ!!!",
    Twitter: "",
  },
  {
    No: 160,
    Name: "りき",
    Team: "トップメンテナンス",
    Machine: "クロストレーナー",
    Comment: "目指せタマイチ！",
    Twitter: "",
  },
  {
    No: 161,
    Name: "仲澤凌司",
    Team: "",
    Machine: "YZ250X",
    Comment: "",
    Twitter: "",
  },
  {
    No: 162,
    Name: "まざいんご",
    Team: "TGCマッスルレーシング",
    Machine: "YZ125X",
    Comment: "タマイチキメタイ",
    Twitter: "",
  },
  {
    No: 163,
    Name: "獅子唐",
    Team: "和田屋SRC 2nd",
    Machine: "YZ125X",
    Comment: "やってやりますよ????????",
    Twitter: "",
  },
  {
    No: 164,
    Name: "キタヤマ",
    Team: "和田屋SRC 2nd",
    Machine: "KX250X",
    Comment: "やってやりますよ。。。",
    Twitter: "",
  },
  {
    No: 165,
    Name: "ミウラ",
    Team: "和田屋SRC2nd",
    Machine: "ヤマハのアレ",
    Comment: "ﾔｯﾃﾔﾘﾏｽﾖ（震え声）",
    Twitter: "",
  },
  {
    No: 166,
    Name: "タイチ",
    Team: "watanohaエンデューロ 関東支部",
    Machine: "RR2T 300",
    Comment: "",
    Twitter: "",
  },
  {
    No: 167,
    Name: "イサ",
    Team: "Watanohaエンデューロ関東支部千葉出張所",
    Machine: "くろとれ三百",
    Comment: "ヘルプ大歓迎",
    Twitter: "",
  },
  {
    No: 168,
    Name: "みやけ",
    Team: "Watanohaエンデューロ関東支部千葉出張所",
    Machine: "YZ250FX",
    Comment: "3速全開マン",
    Twitter: "",
  },
  {
    No: 169,
    Name: "バッタ",
    Team: "ヘタレオフローダー",
    Machine: "クロトレ",
    Comment: "",
    Twitter: "",
  },
  {
    No: 170,
    Name: "カイ",
    Team: "Watanohaエンデューロ関東支部&Stars tradingRT",
    Machine: "te250",
    Comment: "",
    Twitter: "",
  },
  {
    No: 171,
    Name: "ぬまっち",
    Team: "和田屋SRC",
    Machine: "KX100",
    Comment: "",
    Twitter: "",
  },
  {
    No: 172,
    Name: "馬本 勇人",
    Team: "",
    Machine: "crf230f",
    Comment: "",
    Twitter: "",
  },
  {
    No: 173,
    Name: "きんかん",
    Team: "teamそねっち",
    Machine: "ハスクバーナWR125",
    Comment: "マクレないぞ！",
    Twitter: "",
  },
  {
    No: 174,
    Name: "む",
    Team: "",
    Machine: "フリーライド350",
    Comment: "",
    Twitter: "",
  },
  {
    No: 175,
    Name: "ワーダーチャン",
    Team: "TOYZ Racing",
    Machine: "BETA RR2T200",
    Comment: "",
    Twitter: "",
  },
  {
    No: 176,
    Name: "らいす",
    Team: "",
    Machine: "RMZ250",
    Comment: "初レース!最後まで楽しむ!",
    Twitter: "",
  },
  {
    No: 177,
    Name: "奥卓也",
    Team: "アドブ",
    Machine: "TE300i",
    Comment: "",
    Twitter: "",
  },
  {
    No: 178,
    Name: "TOTO",
    Team: "吉田ジンギスカン with jon it.",
    Machine: "YAMAHA YZ125X",
    Comment: "10代の根性、見せてやりますよぉ！！",
    Twitter: "",
  },
  {
    No: 179,
    Name: "こまこま",
    Team: "和田屋SRC",
    Machine: "たぶんクロトレ",
    Comment: "お酒って怖い！",
    Twitter: "",
  },
  {
    No: 180,
    Name: "yUSA",
    Team: "ストレンジ Team月曜会",
    Machine: "RR2T200",
    Comment: "エルデンリング",
    Twitter: "",
  },
  {
    No: 181,
    Name: "なつ",
    Team: "",
    Machine: "KX85II",
    Comment: "やれる所までやってやります??",
    Twitter: "",
  },
  {
    No: 182,
    Name: "多川 潤",
    Team: "BONSAIMOTO",
    Machine: "KTM150XC-W",
    Comment: "少しでも先に",
    Twitter: "",
  },
  {
    No: 183,
    Name: "Marichang",
    Team: "Runbler",
    Machine: "Ktm300exc",
    Comment: "",
    Twitter: "",
  },
  {
    No: 184,
    Name: "渋口 通",
    Team: "チームJOK",
    Machine: "rr2t 300",
    Comment: "がんばりまっす",
    Twitter: "",
  },
  {
    No: 185,
    Name: "しんちゃん",
    Team: "",
    Machine: "セロー２５０",
    Comment: "",
    Twitter: "",
  },
  {
    No: 186,
    Name: "そねっち",
    Team: "ツーリス党",
    Machine: "YZ250FX",
    Comment: "笑顔で帰宅！（怪我なく完走）",
    Twitter: "",
  },
  {
    No: 187,
    Name: "オガ",
    Team: "",
    Machine: "wr250r",
    Comment: "がんばります！",
    Twitter: "",
  },
  {
    No: 188,
    Name: "OTSUKA",
    Team: "チームワーロック",
    Machine: "YAMAHA  YZ250FX",
    Comment: "時間内ゴールを目指します。",
    Twitter: "",
  },
  {
    No: 189,
    Name: "おかけん",
    Team: "",
    Machine: "CRF100F",
    Comment: "ミニモトはイイぞ！",
    Twitter: "",
  },
  {
    No: 190,
    Name: "ササキ",
    Team: "Gotofactory",
    Machine: "rr2t200",
    Comment: "",
    Twitter: "",
  },
  {
    No: 191,
    Name: "MAC",
    Team: "TOYZ Racing",
    Machine: "Beta RR2T300",
    Comment: "",
    Twitter: "",
  },
  {
    No: 192,
    Name: "伊藤建",
    Team: "ゴールドウインモーターサイクル",
    Machine: "te150i",
    Comment: "ゴールドウインの卍見せてやります",
    Twitter: "",
  },
  {
    No: 193,
    Name: "JJ",
    Team: "和田屋src",
    Machine: "KX112",
    Comment: "2nd全員やっつける",
    Twitter: "",
  },
  {
    No: 194,
    Name: "がく",
    Team: "トランスきのこRACING",
    Machine: "KTM 250EXC TPI",
    Comment: "楽しみにしてます",
    Twitter: "",
  },
  {
    No: 195,
    Name: "あやと Off-Road Racer",
    Team: "ビバーク大阪RG3&GASGAS高槻",
    Machine: "GASGAS EC300",
    Comment: "ビリーボルトとバトルする男の走りを見てくれ。",
    Twitter: "",
  },
  {
    No: 196,
    Name: "つるみ",
    Team: "八塔寺老人倶楽部 青年部",
    Machine: "250EXC",
    Comment: "パワー！！ハッ",
    Twitter: "",
  },
  {
    No: 197,
    Name: "ZERO",
    Team: "フレアライン／IMDE／BLACKBOX",
    Machine: "KTM250EXC",
    Comment: "タイちゃん待ってるよ！",
    Twitter: "",
  },
  {
    No: 198,
    Name: "ハチマンタロー",
    Team: "くそみそテクニック",
    Machine: "ヤマハ",
    Comment: "とりあえずお疲れ",
    Twitter: "",
  },
  {
    No: 199,
    Name: "西川輝彦",
    Team: "チームミワコング",
    Machine: "BETA  RR 2T 250",
    Comment: "",
    Twitter: "",
  },
  {
    No: 200,
    Name: "コテツ",
    Team: "ＫＶＯ",
    Machine: "BETA RR2T300",
    Comment: "",
    Twitter: "",
  },
  {
    No: 400,
    Name: "山本鯨",
    Team: "Japan Motocross Academy",
    Machine: "CRF450RX",
    Comment: "",
    Twitter: "",
  },
];
